import { TextProps, ZERO_WIDTH_SPACE, parseTags } from '@features/powerpoint';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { textStyles } from '../utils';

export const NEWLINE_REGEX = /\r?\n/;

export const parsedTakeaways = (keyTakeaways: string[]): TextProps['text'] =>
  keyTakeaways.flatMap(takeaway => {
    if (takeaway.length === 0) {
      return [];
    }

    const parsedContent = parseTags(takeaway);

    return [
      {
        text: ZERO_WIDTH_SPACE,
        options: {
          bullet: true,
          color: unifiedPlatformColorPalette.inmarketGreen,
        },
      },
      ...parsedContent.map(textProps => ({
        ...textProps,
        options: {
          color: textStyles.contentSlideDefaults?.color,
          ...textProps.options,
        },
      })),
    ];
  });
